import { useCatalog } from "@/lib/catalog/context.tsx";
import styles from "./Footer.module.css";

/*
 * The legal pages are plain files in public/, generated by
 * scripts/build-legal.mjs — not routes in this app. So these are ordinary
 * links rather than router pushes: someone checking what the site does with
 * their email address should get a page even when the JavaScript has failed or
 * the service worker is serving something stale.
 */
/* Fixed at build time rather than read from the clock: a footer that silently
 * becomes "© 2027" at midnight on New Year is asserting a fact about
 * publication nobody checked. */
const year = new Date().getFullYear();

export function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <p>
          © {year} {useCatalog().project.copyright}
        </p>
        <nav className={styles.links}>
          <a href="/privacy">Privacy</a>
          <a href="/terms">Terms</a>
        </nav>
      </div>
    </footer>
  );
}
